import React, { useState, useEffect } from "react";
import * as cornerstone from "cornerstone-core";
import * as cornerstoneMath from "cornerstone-math";
import * as cornerstoneTools from "cornerstone-tools";
import Hammer from "hammerjs";
import * as cornerstoneWebImageLoader from "cornerstone-web-image-loader";
import * as cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import * as cornerstoneFileImageLoader from 'cornerstone-file-image-loader';

import * as dicomParser from "dicom-parser";
import { EventEmitter } from "../../../event";
// import FullscreenIcon from '@mui/icons-material/Fullscreen';

// import { IconButton } from "@mui/material";
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import withSnackbar from '../../common/hook/useNotification';
import MyWindowPortal from './MyWindowPortal'
import { getImage, base64ToBuffer } from '../../../service/api.service'
import { AntSwitch, mapCoordinate, PrettoSlider } from "../../common/codeHelper";
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import DcmDialog from "./dcmDialog";
import DcmDialogWOCornerstone from "./DcmDialogWOCornerstone";


cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneWebImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
cornerstoneFileImageLoader.external.cornerstone = cornerstone;
cornerstoneTools.external.Hammer = Hammer;



const styles = {
    bottomRightStyle: {
        bottom: "5px",
        right: "5px",
        position: "absolute",
        color: "white"
    },
    fulldivStyle: {
        height: "90vh",
        position: "relative",
        color: "white"
    },
    divStyle: {
        height: ((window.innerWidth) / 100) * 23.4 + 'px',// "420px",
        width: ((window.innerWidth) / 100) * 23.4 + 'px',// "420px",
        maxWidth: "100%",
        maxHeight: "100%",
        position: "relative",
        color: "white"
    },
    topRightStyle: {
        position: "absolute",
        color: "white",
        fontSize: "10px",
        background: "#2b8f35",
        border: "1px solid #fff",
        borderRadius: "25px",
        height: "30px",
        width: "30px",
        zIndex: "2",
        margin: "5px"
    },
    topLeftStyle: {
        top: "4px",
        left: "15px",
        color: '#fff',
        position: "absolute",
    },
}

// const coordinatesBoudries = [
//     [
//         145,
//         210,
//         177,
//         279
//     ],
//     [
//         207,
//         187,
//         239,
//         261
//     ],
//     [
//         278,
//         178,
//         308,
//         250
//     ],
//     [
//         339,
//         185,
//         388,
//         255
//     ],
//     [
//         387,
//         228,
//         435,
//         277
//     ]
// ];


// The Header creates links that can be used to navigate
// between routes.
let state = {
    imageIds: '',
    sliceData: '',
    coordinate: '',
    currentImageIndex: 0,
    showWindowPortal: '',
    boneName: '',
    totalSaggitalImage: 1,
    offsetPixel: { x: 0, y: 0 },
    offsetFractionY: 0,
    offsetFractionX: 0,
    lineStyle: {
        top: 0,
        visibility: 'hidden',
        height: '5px'
    },
    boneIndex: 0
};



let sagittalViewerElement, ViewerElementDiv;
// let imageLoaded = false;
function SagittalView(props) {


    const [showOriginal, setShowOriginal] = React.useState(true);
    const [idToFetchData, setIdToFetchData] = React.useState();
    const [extraData, setExtraData] = React.useState({ heading: '', height: '0px', width: '0px' });
    const [viewStyle, setViewStyle] = React.useState({ height: '10px', width: '10px' });
    const [showWindowPortal, setShowWindowPortal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState();

    // const [activeDropdown, setActiveDropdown] = useState();



    state = {
        imageIds: state.imageIds,
        coordinate: props?.diskCoOrdinates,
        sliceData: props.sliceData.saggitalImageData,
        currentImageIndex: props.currentIndex,
        showWindowPortal: props.showWindowPortal,
        boneName: state.boneName,
        totalSaggitalImage: props.totalSaggitalImage,
        offsetPixel: { x: 0, y: 0 },
        offsetFractionY: state.offsetFractionY,
        offsetFractionX: state.offsetFractionX,
        lineStyle: state.lineStyle,
        boneIndex: state.boneIndex
    };

    const [lineStyle, setLineStyle] = React.useState(state.lineStyle);
    const [boneIndex, setBoneIndex] = useState(state.boneIndex);



    EventEmitter.subscribe("requesFullScreenElem", (type) => {
        if (type === 'original') {
            if (sagittalViewerElement) {
                if (sagittalViewerElement.requestFullscreen) {
                    sagittalViewerElement.requestFullscreen();
                } else if (sagittalViewerElement.webkitRequestFullscreen) { /* Safari */
                    sagittalViewerElement.webkitRequestFullscreen();
                } else if (sagittalViewerElement.msRequestFullscreen) { /* IE11 */
                    sagittalViewerElement.msRequestFullscreen();
                }
            }
        }
    })




    useEffect(() => {
        loadImage(0);
        EventEmitter.subscribe("zoominpopupclose", (event) => {
            if (event && boneIndex) {
                setTimeout(() => {
                    setLineStyleOnCahnge(state.boneIndex);
                }, 500);
            }
        })

    });

    const loadImage = (id) => {
        if (state.currentImageIndex) {

        }
        if (ViewerElementDiv && viewStyle.width !== ViewerElementDiv.clientWidth) {
            state.imageIds = ''; //to handle change tab load
            setViewStyle({ width: ViewerElementDiv.clientWidth, height: ViewerElementDiv.clientWidth })
        }
        if (currentIndex === undefined && props.currentIndex) {
            setCurrentIndex(props.currentIndex - 1)
        }
        cornerstoneTools.getModule("segmentation").configuration.segmentsPerLabelmap = 0
        cornerstoneTools.init({
            mouseEnabled: true,
            touchEnabled: true,
            globalToolSyncEnabled: true,
            showSVGCursors: true,
        });
        if (sagittalViewerElement && state.sliceData[currentIndex]) {
            cornerstone.enable(sagittalViewerElement);
            let idToFetchData = state.sliceData[currentIndex].fileIds[1]; // state.imageIds[state.currentImageIndex].analysis;
            let heading = 'Sagittal Slice:' + (currentIndex + 1) + ' (ML Analysis)';
            if (showOriginal) {
                idToFetchData = state.sliceData[currentIndex].fileIds[0]; // state.imageIds[state.currentImageIndex].original;
                heading = 'Sagittal Slice:' + (currentIndex + 1) + ' (Original)'
            }
            setIdToFetchData(idToFetchData);
            if (extraData.heading !== heading)
                setExtraData({ heading: heading, height: '512px', width: '512px' });
            if (state.imageIds !== idToFetchData) {
                state.imageIds = idToFetchData;
                getImage(idToFetchData, (resp) => {
                    base64ToBuffer('data: image / png; base64,' + resp.fileData, (buf) => {
                        const imageId = cornerstoneFileImageLoader.fileManager.addBuffer(buf);
                        if (imageId) {
                            cornerstone.loadAndCacheImage(imageId).then((image) => {
                                // Display the first image
                                // imageLoaded = true;
                                if (sagittalViewerElement) {
                                    cornerstone.displayImage(sagittalViewerElement, image);
                                }
                            });
                        }
                    })

                });

                // if (lineStyle.visibility !== 'visible' || lineStyle.top === 0) {
                sagittalViewerElement.addEventListener("cornerstonetoolsmouseclick", function (ev) {
                    const points = ev.detail.currentPoints.image;
                    state.lineStyle = { top: ev.detail.currentPoints.canvas.y, visibility: 'visible', height: '10px' }
                    setLineStyle({ top: ev.detail.currentPoints.canvas.y, visibility: 'visible', height: '10px' })
                    checkIsPointInPoly(points.x, points.y, ev.detail.currentPoints.canvas.y);
                });
                // }
                if (state.offsetFractionY === 0) {
                    sagittalViewerElement.addEventListener('cornerstoneimagerendered', (e) => {
                        if (sagittalViewerElement) {
                            const offsetx = sagittalViewerElement.offsetLeft;
                            const offsety = sagittalViewerElement.offsetTop;
                            const offsetxend = sagittalViewerElement.offsetLeft + sagittalViewerElement.offsetWidth;
                            const offsetyend = sagittalViewerElement.offsetTop + sagittalViewerElement.offsetHeight;
                            const positionStart = cornerstone.pageToPixel(sagittalViewerElement, offsetx, offsety);
                            const positionEnd = cornerstone.pageToPixel(sagittalViewerElement, offsetxend, offsetyend);

                            const equivalentPagex = offsetxend - offsetx;
                            const equivalentPagey = offsetyend - offsety;
                            const equivalentCanvasx = Math.abs(positionEnd.x) - Math.abs(positionStart.x);
                            const equivalentCanvasy = Math.abs(positionEnd.y) - Math.abs(positionStart.y);

                            state.offsetFractionY = equivalentPagey / equivalentCanvasy;
                            state.offsetFractionX = equivalentPagex / equivalentCanvasx;
                            const position00 = cornerstone.pageToPixel(sagittalViewerElement, 0, 0);
                            const position100200 = cornerstone.pageToPixel(sagittalViewerElement, 100, 200);
                            const position200300 = cornerstone.pageToPixel(sagittalViewerElement, 200, 300);

                            const x1 = Math.abs(position00.x) - Math.abs(position100200.x);
                            const y1 = Math.abs(position00.y) - Math.abs(position100200.y);
                            const x2 = Math.abs(position100200.x) - Math.abs(position200300.x);
                            const y2 = Math.abs(position100200.y) - Math.abs(position200300.y);

                            const x3 = Math.abs(Math.abs(x2) - Math.abs(x1))
                            const y3 = Math.abs(Math.abs(y2) - Math.abs(y1))
                            state.offsetPixel = { x: x3, y: y3 }
                        }

                    });
                }
            }
        }
    }

    function checkIsPointInPoly(clientX, clientY, canvasY) {
        let inside = false;
        let count = 0;
        for (let i = 0; i < state.coordinate.length; i++) {
            const curCoordinates = state.coordinate[i].coOrdinates;
            let xAxis = mapCoordinate(curCoordinates[1]), yAxis = mapCoordinate(curCoordinates[0]), h = mapCoordinate(curCoordinates[2]) - mapCoordinate(curCoordinates[0]), w = mapCoordinate(curCoordinates[3]) - mapCoordinate(curCoordinates[1]);
            if (xAxis <= clientX && yAxis <= clientY && xAxis + w >= clientX && yAxis + h >= clientY && !inside) {
                inside = true;
                count = i;
            }
        }
        if (inside) {
            state.boneIndex = count + 1;
            setBoneIndex(count + 1);
            const height = mapCoordinate(state.coordinate[count].coOrdinates[2]) - mapCoordinate(state.coordinate[count].coOrdinates[0])
            const coord = state.coordinate[count].coOrdinates;
            if ((Math.trunc(state.offsetFractionY * 100) / 100) !== (Math.trunc(state.offsetFractionX * 100) / 100)) {
                const calc = mapCoordinate(coord[0]) * state.offsetFractionY * 1.4;
                state.lineStyle = { top: calc, visibility: 'visible', height: `${height * state.offsetFractionY * 1.4}px` }
                setLineStyle({ top: calc, visibility: 'visible', height: `${height * state.offsetFractionY * 1.4}px` })
            }
            else {
                const calc = mapCoordinate(coord[0]) * state.offsetFractionY
                state.lineStyle = { top: calc, visibility: 'visible', height: `${height * state.offsetFractionY}px` }
                setLineStyle({ top: calc, visibility: 'visible', height: `${height * state.offsetFractionY}px` })
            }

            let name = `L${count + 1}-L${count + 2}`;
            if (count === 4) {
                name = `L${count + 1}-S1`;
            }
            props.snackbarShowMessage(`Clicked on ${name}`);
            props.ChangeSelectionCallback(count + 1);
        }

    }

    EventEmitter.subscribe("dropdownSelectChange", (event) => {
        // if (event === 1) { 
        // setActiveDropdown(event);
        if (state.offsetFractionY === 0) {
            setTimeout(() => {
                setLineStyleOnCahnge(event);
            }, 1500);
        } else {
            setLineStyleOnCahnge(event);
        }


    })

    function setLineStyleOnCahnge(ev) {
        state.boneIndex = ev;
        setBoneIndex(ev);
        if (ev && state.coordinate && state.offsetFractionY !== 0) {
            const height = mapCoordinate(state.coordinate[ev - 1].coOrdinates[2]) - mapCoordinate(state.coordinate[ev - 1].coOrdinates[0])
            const coord = state.coordinate[ev - 1].coOrdinates;
            if ((Math.trunc(state.offsetFractionY * 100) / 100) !== (Math.trunc(state.offsetFractionX * 100) / 100)) {
                const calc = mapCoordinate(coord[0]) * state.offsetFractionY * 1.4
                state.lineStyle = { top: calc, visibility: 'visible', height: `${height * state.offsetFractionY * 1.4}px` };
                setLineStyle({ top: calc, visibility: 'visible', height: `${height * state.offsetFractionY * 1.4}px` });
            }
            else
                state.lineStyle = { top: mapCoordinate(coord[0]) * state.offsetFractionY, visibility: 'visible', height: `${height * state.offsetFractionY}px` };
            setLineStyle({ top: mapCoordinate(coord[0]) * state.offsetFractionY, visibility: 'visible', height: `${height * state.offsetFractionY}px` });
        }
    }

    EventEmitter.subscribe("saggitalSelectChange", (event) => {
        if (currentIndex !== event) {
            state.currentImageIndex = event;
            setCurrentIndex(event)
            loadImage(event);
        }
    });

    const handleChangeSlider = (event, newValue, activeThumb) => {

        if (currentIndex !== event.target.value - 1) {
            state.currentImageIndex = event.target.value - 1;
            setCurrentIndex(event.target.value - 1)
            loadImage(event.target.value - 1);
        }
    };

    function handleToggleClick() {
        setShowOriginal(!showOriginal);
    }





    // function requestNewTabWindow() {
    //     setTimeout(() => {
    //         setShowOriginal(!showOriginal);
    //     }, 100);
    //     setShowWindowPortal(!showWindowPortal);

    // }

    const handleSetShowWindowPortal = () => {
        setShowWindowPortal(!showWindowPortal);
    };

    return (
        <div className="grid grid-cols-10 sagittal-view">
            <div className="col-span-10" ref={(input) => {
                ViewerElementDiv = input;
            }}>
                <div style={styles.topRightStyle}>

                    <DcmDialogWOCornerstone image={idToFetchData} extraData={extraData}></DcmDialogWOCornerstone>

                </div>
                <div
                    className="viewportElement"
                    style={state.showWindowPortal ? styles.fulldivStyle : {
                        height: viewStyle.height,// "420px",
                        width: viewStyle.width,// "420px",
                        maxWidth: "100%",
                        maxHeight: "100%",
                        position: "relative",
                        color: "white"
                    }}
                    ref={(input) => {
                        sagittalViewerElement = input;
                        loadImage(currentIndex);
                    }}
                >
                    <canvas className="cornerstone-canvas" />

                    <div id="lineToshowBone" style={{
                        top: lineStyle.top,
                        visibility: lineStyle.visibility,
                        height: lineStyle.height,
                        border: '1px solid #32ff2c',
                        position: "absolute",
                        width: "90%",
                        left: "5%"
                    }}></div>
                </div>
                <div className="">
                    <div className="flex">
                        <div className="pr-2 pl-1 font-semibold self-center w-1/3 text-blue-700"> Sagittal</div>
                        <div className="py-2 text-right w-2/3">
                            <Stack className="float-right right-2 relative" direction="row" spacing={1} alignItems="center">
                                <Typography sx={{ fontSize: '13px' }}>ML Analysis</Typography>
                                <AntSwitch checked={showOriginal}
                                    onChange={() =>
                                        handleToggleClick()
                                    }
                                    inputProps={{ 'aria-label': 'ant design' }} />
                                <Typography sx={{ fontSize: '13px' }}>Original</Typography>
                            </Stack>
                        </div>
                    </div>
                    <div className="px-3">
                        {props.currentIndex && <PrettoSlider
                            valueLabelDisplay="auto"
                            aria-label="pretto slider"
                            defaultValue={props.currentIndex}
                            step={1}
                            marks
                            min={1}
                            max={state.totalSaggitalImage}
                            onChange={handleChangeSlider}
                        />}
                    </div>
                </div>
            </div>

            {showWindowPortal &&
                (
                    <MyWindowPortal closeWindowPortal={handleSetShowWindowPortal} portalCallback={handleSetShowWindowPortal}>
                        <div className="col-span-10  drop-shadow-md">
                            <div
                                className="viewportElement"
                                style={styles.fulldivStyle}
                                ref={(input) => {
                                    sagittalViewerElement = input;
                                    loadImage(currentIndex);
                                }}
                            >
                                <canvas className="cornerstone-canvas" />

                                <div id="lineToshowBone" style={{
                                    top: lineStyle.top,
                                    visibility: lineStyle.visibility,
                                    height: lineStyle.height,
                                    border: '1px solid #32ff2c',
                                    position: "absolute",
                                    width: "90%",
                                    left: "5%"
                                }}></div>
                            </div>
                            <div className="">
                                <div className="flex">
                                    <div className="px-2 font-semibold self-center w-1/2">
                                        Sagittal
                                    </div>
                                    <div className="text-right w-1/2">
                                        <Stack className="float-right right-2 relative" direction="row" spacing={1} alignItems="center">
                                            <Typography>ML Analysis</Typography>
                                            <AntSwitch checked={showOriginal}
                                                onChange={() =>
                                                    handleToggleClick()
                                                }
                                                inputProps={{ 'aria-label': 'ant design' }} />
                                            <Typography>Original</Typography>
                                        </Stack>

                                    </div>
                                </div>
                                <div className="px-3">
                                    {props.currentIndex && <PrettoSlider
                                        valueLabelDisplay="auto"
                                        aria-label="pretto slider"
                                        defaultValue={props.currentIndex}
                                        step={1}
                                        marks
                                        min={1}
                                        max={state.totalSaggitalImage}
                                        onChange={handleChangeSlider}
                                    />}
                                </div>
                            </div>
                        </div>
                    </MyWindowPortal>
                )
            }


        </div>
    );
}

export default withSnackbar(SagittalView);